import { IconName, MemreBoxSelection } from 'components/core';
import { useAuthoringContext } from '../../AuthoringContext';
import { isGovcloud } from 'utils/environmentUtils';

export default function EmptyBlock({ item }) {
  const { set } = useAuthoringContext();

  const allowedVideoPartners = [7385, 15487, 16853]; // AETC, 368th, USMC

  const partnerId = parseInt(set?.creator?.id ?? 0);
  const parentPartnerId = parseInt(set?.creator?.parentId ?? 0);

  const canUseVideo =
    isGovcloud() || allowedVideoPartners.includes(partnerId) || allowedVideoPartners.includes(parentPartnerId);

  const cardTypes = [
    { type: 'image', icon: IconName.image },
    { type: 'text', icon: IconName.text },
    { type: 'sound', icon: IconName.sound },
    ...(canUseVideo ? [{ type: 'video', icon: IconName.video }] : []),
    { type: 'embed', icon: IconName.embed },
  ];

  return <MemreBoxSelection cardTypes={cardTypes} handleCardClick={item.setType} />;
}
